// extracted by mini-css-extract-plugin
export default {"container":"sort_price_container__TcmjO"};